<script>
import ConvenioProvider from "@/modules/cobrox/providers/ConvenioProvider";
import dayjs from "dayjs";
import {DayjsMixin} from "@dracul/dayjs-frontend";
import ConvenioCard from "@/modules/cobrox/components/ConvenioCard/ConvenioCard.vue";

export default {
  name: "ConveniosPorVencer",
  components: {ConvenioCard},
  mixins: [DayjsMixin],
  data() {
    return {
      loading: false,
      reporteConveniosPorVencer: [],
      conveniosPorVencerAplicados: [],
      convenioSelected: null,
      convenioDialog: false,
      selectedConvenios: [],
      headers: [
        {text: 'Convenio', value: 'actions', sortable: false, width: '1%'},
        {text: 'Creado', value: 'createdAt'},
        {text: 'Estado', value: 'estado'},
        {text: 'DNI', value: 'dniDeudor'},

        {text: 'Cuotas Vencidas', value: 'pagosVencidos'},
        {text: 'Monto Vencido', value: 'montoVencido'},
        {text: 'Cobranzas', value: 'cobranzas'},
        {text: 'Monto Cobrado', value: 'montoCobrado'},
        {text: '% Vencido', value: 'porcentajeVencido'},

        {text: 'Ultima Cobranza', value: 'fechaUltimaCobranza'},
      ]
    }
  },
  mounted() {
    this.obtenerReporteConveniosPorVencer();
  },
  methods: {
    dayjs,
    async obtenerReporteConveniosPorVencer() {
      try {
        this.loading = true;
        let r = await ConvenioProvider.fetchConveniosPorVencer()
        this.reporteConveniosPorVencer = r.data.fetchConveniosPorVencer;

      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async aplicarConveniosPorVencer() {
      try {
        this.loading = true;
        const selectedIds = this.selectedConvenios.map(item => item.id)
         await ConvenioProvider.aplicarConveniosPorVencer(selectedIds)
        this.selectedConvenios = []
        this.loading = false;
        this.obtenerReporteConveniosPorVencer()
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    showConvenio(convenio) {
      this.convenioSelected = convenio;
      this.convenioDialog = true;
    }
  }
}
</script>

<template>
  <v-container fluid>

    <v-card :loading="loading">
      <v-card-title>Convenios VIGENTE a POR VENCER</v-card-title>
      <v-card-subtitle>Esta pantalla muestra únicamente los convenios en estado VIGENTE que cumplen las condiciones para pasar al estado “POR VENCER”, pero que aún no fueron actualizados.
        Aquí podés seleccionarlos y aplicar manualmente el cambio de estado mediante el botón “Aplicar Convenios Por Vencer”.</v-card-subtitle>
      <v-card-text>
        <v-data-table
            v-model="selectedConvenios"
            :headers="headers"
            :items="reporteConveniosPorVencer"
            item-key="id"
            show-select
            class="elevation-1"
            :items-per-page="15"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn @click="showConvenio(item)">Ver</v-btn>
          </template>

          <template v-slot:item.createdAt="{ item }">
            {{ getDateFormat(item.createdAt) }}
          </template>

          <template v-slot:item.pagosVencidos="{ item }">
            {{ item.metricas.pagosVencidos.toLocaleString('es-AR') }}
          </template>

          <template v-slot:item.montoVencido="{ item }">
            {{ item.metricas.montoVencido.toLocaleString('es-AR') }}
          </template>

          <template v-slot:item.montoCobrado="{ item }">
            {{ item.metricas.montoCobrado.toLocaleString('es-AR') }}
          </template>

          <template v-slot:item.porcentajeVencido="{ item }">
            {{ item.metricas.porcentajeVencido.toFixed(2) }}%
          </template>

          <template v-slot:item.cobranzas="{ item }">
            {{ item.cobranzas.length }}
          </template>

          <template v-slot:item.fechaUltimaCobranza="{ item }">
            {{ item.fechaUltimaCobranza ? dayjs(item.fechaUltimaCobranza).format("YYYY-MM-DD") : '' }}
          </template>

        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" @click="aplicarConveniosPorVencer"
               :disabled="selectedConvenios.length === 0">APLICAR CONVENIOS POR VENCER
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="convenioDialog">
      <convenio-card :convenio="convenioSelected"/>
    </v-dialog>

  </v-container>
</template>

<style scoped>

</style>
